import React, { useState } from 'react';
import { CompanyAPI } from 'api/company';
import { ImageUpload } from 'components/molecules/image-upload';
import { useTranslation } from 'hooks/use-translation';

export const LogoChange = ({
  src,
  alt,
  onChangeCallback,
  disabled = false,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [companyLogoUrl, setCompanyLogoUrl] = useState<string>(src);
  const buttonText = `${useTranslation('upload_logo')}...`;
  const helpText = useTranslation('project.settings.image.help.recommended');

  const customUploadRequest = (args) => {
    const { file } = args;

    setIsUploading(true);
    CompanyAPI.uploadPicture(file)
      .then((res) => {
        onChangeCallback(res);
        setCompanyLogoUrl(res.location);
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  return (
    <ImageUpload
      onUpload={customUploadRequest}
      isLoading={isUploading}
      isDisabled={disabled}
      src={companyLogoUrl}
      alt={alt}
      buttonText={buttonText}
      help={helpText}
      showSizeRestriction
      showFormatRestriction
    />
  );
};
